var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    { attrs: { active: _vm.active }, on: { close: _vm.close } },
    [
      _c("div", { staticClass: "modal-card" }, [
        _c("header", { staticClass: "modal-card-head" }, [
          _c("p", { staticClass: "modal-card-title" }, [
            _vm._v(_vm._s(_vm.$t("emergency_modal_title")))
          ])
        ]),
        _vm._v(" "),
        _c("section", { staticClass: "modal-card-body" }, [
          _c(
            "div",
            { staticClass: "content" },
            [
              _c("div", { staticClass: "columns is-multiline" }, [
                _c("div", { staticClass: "column is-12" }, [
                  _c("div", { staticClass: "field" }, [
                    _c("label", [_vm._v(_vm._s(_vm.$t("office_name_label")))]),
                    _vm._v(" "),
                    _c("p", { staticClass: "is-size-7" }, [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.availability.officeName))
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "column is-6" }, [
                  _c("div", { staticClass: "field" }, [
                    _c("label", [_vm._v(_vm._s(_vm.$t("date_label")))]),
                    _vm._v(" "),
                    _c("p", { staticClass: "is-size-7" }, [
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm._f("momentFormat")(
                              _vm.availability.date,
                              "YYYY-MM-DD",
                              _vm.$t("date_selector_format")
                            )
                          )
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "column is-6" }, [
                  _c("div", { staticClass: "field" }, [
                    _c("label", [_vm._v(_vm._s(_vm.$t("time_label")))]),
                    _vm._v(" "),
                    _c("p", { staticClass: "is-size-7" }, [
                      _c("strong", [
                        _vm._v(
                          _vm._s(_vm.availability.start) +
                            " - " +
                            _vm._s(_vm.availability.end)
                        )
                      ])
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("h5", { staticClass: "title is-5" }, [
                _vm._v(_vm._s(_vm.$t("patient_symptoms_title")))
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "columns is-multiline" },
                _vm._l(_vm.emergency.symptoms, function(symptom) {
                  return _c("div", { staticClass: "column is-6" }, [
                    _c("div", { staticClass: "field" }, [
                      _c("label", {
                        domProps: { textContent: _vm._s(symptom.question) }
                      }),
                      _vm._v(" "),
                      _c("p", { staticClass: "is-size-7" }, [
                        _c("strong", {
                          domProps: { textContent: _vm._s(symptom.answer) }
                        })
                      ])
                    ])
                  ])
                }),
                0
              ),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("h5", { staticClass: "title is-5" }, [
                _vm._v(_vm._s(_vm.$t("patient_information_title")))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "columns is-multiline" }, [
                _c("div", { staticClass: "column is-4" }, [
                  _c("div", { staticClass: "field" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("patient_first_name_label")))
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "is-size-7" }, [
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.emergency.patientFirstName
                              ? _vm.hashPatientInfo(
                                  _vm.emergency.patientFirstName
                                )
                              : "N/A"
                          )
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "column is-4" }, [
                  _c("div", { staticClass: "field" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("patient_last_name_label")))
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "is-size-7" }, [
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.emergency.patientLastName
                              ? _vm.hashPatientInfo(
                                  _vm.emergency.patientLastName
                                )
                              : "N/A"
                          )
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "column is-4" }, [
                  _c("div", { staticClass: "field" }, [
                    _c("label", [_vm._v(_vm._s(_vm.$t("patient_age_label")))]),
                    _vm._v(" "),
                    _c("p", { staticClass: "is-size-7" }, [
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.emergency.patientAge
                              ? _vm.emergency.patientAge
                              : "N/A"
                          )
                        )
                      ])
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "columns is-multiline" }, [
                _c("div", { staticClass: "column is-4" }, [
                  _c("div", { staticClass: "field" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("patient_email_label")))
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "is-size-7" }, [
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.emergency.patientEmail
                              ? _vm.hashPatientInfo(_vm.emergency.patientEmail)
                              : "N/A"
                          )
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "column is-4" }, [
                  _c("div", { staticClass: "field" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("patient_phone_label")))
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "is-size-7" }, [
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.emergency.patientPhone
                              ? _vm.hashPatientInfo(_vm.emergency.patientPhone)
                              : "N/A"
                          )
                        )
                      ])
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "columns is-multiline" }, [
                _c("div", { staticClass: "column is-4" }, [
                  _c("div", { staticClass: "field" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("patient_locality_label")))
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "is-size-7" }, [
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.emergency.locality
                              ? _vm.emergency.locality
                              : "N/A"
                          )
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "column is-4" }, [
                  _c("div", { staticClass: "field" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("patient_zip_code_label")))
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "is-size-7" }, [
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.emergency.zipCode
                              ? _vm.emergency.zipCode
                              : "N/A"
                          )
                        )
                      ])
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("h5", { staticClass: "title is-5 mb-0" }, [
                _vm._v(_vm._s(_vm.$t("pictures_title")))
              ]),
              _vm._v(" "),
              _vm.emergency.pictures.length == 0
                ? _c("div", { staticClass: "message is-warning my-3" }, [
                    _c("div", { staticClass: "message-body" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("no_pictures_placeholder")) +
                          "\n                    "
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.emergency.pictures, function(picture) {
                return _c(
                  "figure",
                  {
                    staticClass: "image thumbnail is-128x128 is-inline-block",
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.showPicture(picture)
                      }
                    }
                  },
                  [
                    _c("img", {
                      attrs: { src: picture, alt: _vm.$t("picture_alt") }
                    })
                  ]
                )
              })
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c("footer", { staticClass: "modal-card-foot" }, [
          _c(
            "button",
            {
              staticClass: "button",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.close($event)
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("close_button_label")))]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f3670ea8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f3670ea8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Doctor/EmergencyModal.vue
// module id = 614
// module chunks = 1